import React, {useEffect} from "react";

// // layouts
import VerticalLayout from "./components/VerticalLayout/";

// Import scss
import "./assets/scss/theme.scss";
import {useLocation, Outlet, useNavigate} from "react-router-dom";

// Activating fake backend

const App = () => {
  const {pathname} = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (pathname === '/') {
      navigate('/dashboard', {replace: true})
    }
  }, [pathname, navigate])
  return (
    <VerticalLayout location={ pathname.split('/').pop()}><Outlet/></VerticalLayout>

  );
}

export default App;
